module.exports = __webpack_public_path__ + "HP_Pagewide.png?a07e44251c8716957cc88a947baa5d72";